/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';


export default {
    
    GetViewGrnInformationByGroupIdFactoryIdDate,
    GetRouteByFactoryID,
    GetAllProductVarietyByProductID,
    GetProductCategoties,
    GetProductTypes,
    GetProductDetails,
    GetAllGroups,
    GetGrnSummaryReportDetails,
    GetUncompletedProductListReportDetails
};

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductTypes() {
    const response = await CommonGet('/api/ProductType/GetAllProductTypes', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetRouteByFactoryID(operationEntityID) {
    const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + parseInt(operationEntityID));
    return response.data;
}

async function GetViewGrnInformationByGroupIdFactoryIdDate(groupID, operationEntityID, date) {
    const response = await CommonGet('/api/GoodRecieveNote/GetGoodReciveNoteDetails', 'groupID=' + parseInt(groupID)
        + '&factoryID=' + parseInt(operationEntityID) + '&date=' + date);
    return response.data;
}

async function GetAllProductVarietyByProductID(productID) {
    const response = await CommonGet('/api/Product/GetAllProductVarietyByProductID', 'productID=' + productID);
    return response.data;
}

async function GetGrnSummaryReportDetails(model) {
    const response = await CommonPost('/api/GrnSummaryReport/GetGrnSummaryReportDetails', null, model);
    return response.data;
}

async function GetUncompletedProductListReportDetails(date) {
    const response = await CommonPost('/api/UncompletedProductListReport/GetUncompletedProductListReportDetails', 'date=' + (date));
    return response;

}



